import React from 'react';

const TableFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  sortField, 
  setSortField, 
  sortOrder, 
  setSortOrder, 
  columns = [],
  placeholder = "Search...",
  showSort = true 
}) => {
  return (
    <div className="row mb-3">
      <div className="col-md-6">
        <div className="input-group">
          <span className="input-group-text">🔍</span>
          <input
            type="text"
            className="form-control"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {showSort && (
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-6">
              <select
                className="form-select"
                value={sortField}
                onChange={(e) => setSortField(e.target.value)}
              >
                <option value="">Sort by...</option>
                {columns.map(col => (
                  <option key={col.key} value={col.key}>{col.label}</option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <select
                className="form-select"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="asc">↑ Ascending</option>
                <option value="desc">↓ Descending</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const useTableFilters = (data, columns) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [sortField, setSortField] = React.useState('');
  const [sortOrder, setSortOrder] = React.useState('asc');

  const filteredAndSortedData = React.useMemo(() => {
    let filtered = data;

    // Filter
    if (searchTerm) {
      filtered = data.filter(item =>
        columns.some(col => {
          const value = item[col.key];
          return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
        })
      );
    }

    // Sort
    if (sortField) {
      filtered = [...filtered].sort((a, b) => {
        const aVal = a[sortField] || '';
        const bVal = b[sortField] || '';
        
        if (sortOrder === 'asc') {
          return aVal.toString().localeCompare(bVal.toString());
        } else {
          return bVal.toString().localeCompare(aVal.toString());
        }
      });
    }

    return filtered;
  }, [data, searchTerm, sortField, sortOrder, columns]);

  return {
    searchTerm,
    setSearchTerm,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    filteredData: filteredAndSortedData
  };
};

export default TableFilters;